<script setup>
defineProps({
  salida: Object,
  territorios: { type: Array, default: () => [] },
  getTerrKey: { type: Function, required: true },
  captainName: { type: String, default: '' },
  grupoNombre: { type: String, default: '' },
})

defineEmits(['ver-territorio', 'como-llegar'])

const DIAS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']

const fechaTexto = (fecha) => {
  if (!fecha) return ''
  const d = new Date(fecha)
  return `${DIAS[d.getDay()]} ${d.toLocaleDateString('es-AR', { day: 'numeric', month: 'long' })}`
}
</script>

<template>
  <div class="mayores-contenido">
    <p v-if="salida?.date" class="tarjeta-lista__titulo" style="margin-bottom:var(--space-1)">
      <i class="pi pi-calendar" aria-hidden="true" /> {{ fechaTexto(salida.date) }}
    </p>
    <p v-if="salida?.hour" class="tarjeta-lista__detalle">
      <i class="pi pi-clock" aria-hidden="true" /> {{ salida.hour }} hs
    </p>
    <div v-if="captainName || grupoNombre" style="margin-bottom:var(--space-3)">
      <p v-if="captainName" class="tarjeta-lista__detalle">
        <i class="pi pi-user" aria-hidden="true" /> Conductor: {{ captainName }}
      </p>
      <p v-if="grupoNombre" class="tarjeta-lista__detalle">
        <i class="pi pi-users" aria-hidden="true" /> Grupo {{ grupoNombre }}
      </p>
    </div>

    <div v-if="salida?.puntoEncuentro?.latlng" class="tarjeta-accion">
      <p class="tarjeta-lista__detalle" style="margin-bottom:var(--space-1)">
        <i class="pi pi-map-marker" aria-hidden="true" />
        {{ salida.puntoEncuentro.name || salida.puntoEncuentro.direccion || 'Punto de encuentro' }}
      </p>
      <button type="button" class="boton-secundario" @click="$emit('como-llegar', salida.puntoEncuentro.latlng)">
        <i class="pi pi-map-marker" aria-hidden="true" /> Abrir GPS
      </button>
    </div>

    <p class="campo__etiqueta">Territorios asignados</p>

    <div v-if="!territorios.length" class="mayores-estado">
      <i class="pi pi-map mayores-estado__icono" aria-hidden="true" />
      <p>Todavía no hay territorios asignados a esta salida.</p>
    </div>

    <div v-for="terr in territorios" :key="getTerrKey(terr)" class="mayores-terr-fila">
      <p class="mayores-terr-fila__numero">Territorio {{ getTerrKey(terr) }}</p>
      <button type="button" class="boton-secundario mayores-terr-fila__boton" @click="$emit('ver-territorio', getTerrKey(terr))">
        Ver
      </button>
    </div>
  </div>
</template>
